module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup-container"
  }, [_c('a', {
    staticClass: "login-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v("Already have an account?")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Daily UI")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Welcome!")]), _vm._v(" "), _c('form', {
    staticClass: "signup-form"
  }, [_c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focused),
      expression: "focused"
    }],
    staticClass: "username",
    attrs: {
      "type": "text",
      "placeholder": "Full Name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "focus": function($event) {
        _vm.focused = true
      },
      "blur": function($event) {
        _vm.focused = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "join-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("SIGN UP")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "email",
    attrs: {
      "type": "email",
      "placeholder": "E-mail Address"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "password",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ec9ce27"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signup.vue
// module id = 19
// module chunks = 0